export default __webpack_public_path__ + "static/media/goopter-ecommerce-customer-database.8ddffaeb.png";